import Vue from "vue";

export default new Vue({
  data: () => ({
    user: null,
    loading: false,
  }),
});
